// extracted by mini-css-extract-plugin
export default {"root":"BulkRemoveSuperBatchesModal_root__RrCkV"};